'use client'

import * as React from 'react'

import { useSelectedOrgUnitId } from '@/hooks/useSelectedOrgUnitId'

interface QuickSearchContextProps {
  searchText: string
  setSearchText: React.Dispatch<React.SetStateAction<string>>
}

export const QuickSearchContext = React.createContext<QuickSearchContextProps>({
  searchText: '',
  setSearchText: () => '',
})

const QuickSearchContextProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [searchText, setSearchText] = React.useState('')

  const selectedOrgUnitId = useSelectedOrgUnitId()
  const previousOrgUnitId = React.useRef(selectedOrgUnitId)

  React.useEffect(() => {
    if (previousOrgUnitId.current === selectedOrgUnitId) {
      return
    }

    previousOrgUnitId.current = selectedOrgUnitId
    setSearchText('')
  }, [selectedOrgUnitId])

  return <QuickSearchContext.Provider value={{ searchText, setSearchText }}>{children}</QuickSearchContext.Provider>
}

export default QuickSearchContextProvider
